import {CopilotIcon} from '@primer/octicons-react'
import {ButtonGroup} from '@primer/react'
import {NavLinkItem} from '../../primitives/NavItemLink'
import {GlobalAgentsMenuWithAnchor, type GlobalAgentsMenuProps} from '@github-ui/global-agents-menu/GlobalAgentsMenu'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {GlobalCopilotMenuWithAnchor} from '@github-ui/global-copilot-menu/GlobalCopilotMenu'
import {clsx} from 'clsx'
import baseStyles from '../../primitives/styles.module.css'
import styles from './CopilotItems.module.css'
import {useGlobalNavAnalytics} from '../../utils/Analytics'

export type CopilotItemsProps = {
  show?: boolean
  showCopilotTitle?: boolean
  showAgentsButton?: boolean
  agentsPanel?: {
    popoverAvailable?: boolean
    repository: GlobalAgentsMenuProps['repository']
    agentsButtonId?: string
    showNotification?: boolean
  }
}

export function CopilotItems(props: CopilotItemsProps) {
  const {sendItemClick} = useGlobalNavAnalytics('COPILOT')

  if (!props.show) {
    return null
  }

  const copilotItemProps = {
    href: '/copilot',
    icon: CopilotIcon,
    'aria-label': 'Chat with Copilot',
    analyticsKey: 'COPILOT_CHAT',
    analyticsSubCategory: 'COPILOT',
    linkText: props.showCopilotTitle ? 'Copilot' : undefined,
  }

  return (
    <ButtonGroup>
      <NavLinkItem {...copilotItemProps} />
      {props.showAgentsButton && props.agentsPanel ? (
        <GlobalAgentsMenuWithAnchor
          {...props.agentsPanel}
          anchorProps={{
            variant: 'invisible',
            className: clsx(
              baseStyles.appHeaderButton,
              styles.AgentsMenu,
              props.agentsPanel.showNotification && styles.hasNotification,
            ),
            onClick: () => {
              sendItemClick('AGENTS_MENU')
            },
          }}
        />
      ) : (
        <GlobalCopilotMenuWithAnchor
          anchorProps={{
            variant: 'invisible',
            className: clsx(baseStyles.appHeaderButton, styles.CopilotMenu),
            onClick: () => {
              sendItemClick('COPILOT_MENU')
            },
          }}
        />
      )}
    </ButtonGroup>
  )
}

try{ CopilotItems.displayName ||= 'CopilotItems' } catch {}